import cn from 'classnames';
import * as React from 'react';

import { ReactComponent as DropdownArrow } from '../../../../assets/images/icon-arrow-down.svg';
import { BUTTON_BUTTON } from '../../../../types/forms';
import { IFiltersRef } from '../../../../types/tables';

import styles from './ControlButton.module.scss';

interface IProps {
  label: string;
  onClick?: () => void;
  isOpened: boolean;
  readOnly?: boolean;
  dataAction?: string;
  muiArrow?: boolean;
  filtersRef?: React.Ref<IFiltersRef>;
  filterStyle?: boolean;
}

const ControlButton = React.forwardRef(
  (
    { label, onClick, isOpened, readOnly, dataAction, muiArrow = false, filtersRef, filterStyle = false }: IProps,
    ref,
  ) => {
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    React.useImperativeHandle(ref, () => buttonRef.current as HTMLButtonElement);

    React.useImperativeHandle(
      filtersRef,
      () => ({
        resetFilters: () => undefined,
      }),
      [],
    );

    return (
      <button
        ref={buttonRef}
        onClick={onClick}
        className={cn(styles.toggle, {
          [styles.opened]: isOpened,
          [styles.filterStyle]: filterStyle,
        })}
        type={BUTTON_BUTTON}
        disabled={readOnly}
        data-action={dataAction}
      >
        {label}
        {!readOnly && <DropdownArrow className={cn(styles.icon, { [styles.muiArrow]: muiArrow })} />}
      </button>
    );
  },
);

export default ControlButton;
